import { Button, Fab, Tab, Tabs, Tooltip, Typography, IconButton, TextField, InputAdornment, Modal, Select, MenuItem, FormControl, InputLabel, Paper } from "@mui/material";
import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import Box from "@mui/material/Box";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import { DataGrid, GridToolbarContainer, GridToolbarColumnsButton, GridToolbarFilterButton, GridToolbarExport,} from "@mui/x-data-grid";
import { Add, Search, CalendarToday } from "@mui/icons-material";
import clearFilterImage from "../../icons/clearFilter.svg"
import searchIcon from "../../icons/searchIcon.svg"
import DeleteIcon from "@mui/icons-material/Delete";
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import { TABS } from "../../constants";
import OpaqueLoading from "../../components/opaqueLoading/opaqueLoading";
import "../../App.css";
import ProductModal from "../../components/modals/productModal";
import BulkProductAdd from "../../components/modals/bulkProductAdd";
import SeriesCategory from "../../components/modals/addSeriesCategory";
import ProductMittplusModal from "../../components/modals/productMittplusModal";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

const isMobile = window.innerWidth < 900;

const StaffEditorPageContainer = styled.div`
  height: ${isMobile ? `auto` : `calc(100vh - 105px)`};
  width: 100%;
  background-color: white;
  padding: 10px 15px;
  ${isMobile && `position: relative;`}
`;

const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 7px;
`;

const TableContainer = styled.div`
  width: 100%;
  border: solid 1px lightGrey;
  border-radius: 8px;
`;

const StyledTabs = styled(Tabs)`
  border-bottom: solid 1px lightGrey;
`;

const DataGridContainer = styled.div`
  max-width: 100%;
  margin: 0 auto;
  height: 100%;
  width: 100%;
  display: ${isMobile ? "flex" : "grid"};
  border-radius: 4px;
  ${isMobile && `flex-direction: column;`}
`;

const TabsContainer = styled.div`
  ${isMobile && `height: calc(100vh - 56px - 20px - 43.77px);`}
`;

const ProductManagement = (props) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationModel, setPaginationModel] = useState({
    page: currentPage - 1,
    pageSize: 20,
  });

  const [currentPage1, setCurrentPage1] = useState(1);
  const [paginationModel1, setPaginationModel1] = useState({
    page: currentPage1 - 1,
    pageSize: 11,
  });

  const [selectedTab, setSelectedTab] = useState(TABS.REGISTERED);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState(false);

  const [bulk, setBulk] = useState(false);
  const [series, setSeries] = useState(false);
  const [visitModal, setVisitModal] = useState(false);
  const [olympaidProductsModal, setOlympaidProductsModal] = useState(false);
  const [mittplusProduct, setMittplusProduct] = useState(false);
    const [userData, setUserData] = useState(JSON.parse(localStorage.getItem('storedUserData')).user)
  const [accessChanges, setAccessChanges] = useState("");
  const [editModal, setEditModal] = useState(false);
  const [editMittplusProduct, setEditMittplusProduct] = useState(false);
  const [dataModal, setDataModal] = useState();
  const [modalData, setModalData] = useState([])
  const [openViewModal, setOpenViewModal] = useState(false)
  const [rowCount, setRowCount] = useState();
  const [rowCount1, setRowCount1] = useState();
  const [rowCount2, setRowCount2] = useState();
  const [fromDate, setFromDate] = useState("")
  const [toDate, setToDate] = useState("")
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [search, setSearch] = useState("")
  const [medium, setMedium] = useState("")
  const [mediumss, setMediumss] = useState([])
  const [classes, setClasses] = useState("")
  const [classeses, setClasseses] = useState([])
  const [board, setBoard] = useState("")
  const [boardss, setBoardss] = useState([])
  const [seriess, setSeriesS] = useState("")
  const [seriesss, setSeriesss] = useState([])
  const [productForm, setProductForm] = useState("");
   const [sessions, setSessions] = useState([]); // from API
      const [selectedSession, setSelectedSession] = useState("");
      const [isDateRangeDisabled, setIsDateRangeDisabled] = useState(false);
      const [isSessionDisabled, setIsSessionDisabled] = useState(false);
      const [modalDataMittstore, setModalDataMittstore] = useState([]);
        const [accessModulesData, setAccessModulesData] = useState([]);
      const [openViewModalMittstore, setOpenViewModalMittstore] = useState(false)
    const [modalDataMittstoreRowData, setModalDataMittstoreRowData] = useState([]);
        const [filteredDate, setFilteredData] = useState({});
        const [callApi, setCallApi] = useState(false);

      
        const fetchSessions = async () => {
          try {
            setLoading(true);
            const response = await window.Platform.database.getAllSessions();
            // if (response?.data) {
            //   setSessions(response.data);
            // }
            if (response?.status) {
           const filterdData1 = response?.data?.filter((ele, ind) => ele?.action == "active")
            setFilteredData(filterdData1[0])
          }
          else {
            window.NotificationUtils.showError("Something Went Wrong in session")
          }
          } catch (error) {
            console.error("Error fetching sessions:", error);
            window.NotificationUtils.showError("Failed to load sessions");
          } finally {
            setLoading(false);
          }
        };
  
          // useEffect(() => {
          //   if (!fromDate && !toDate) {
          //     setIsSessionDisabled(false);
          //   }
          // }, [fromDate, toDate]);
        
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(search);
    }, 500);

    return () => clearTimeout(handler);
  }, [search]);

  useEffect(() => {
    fetchSessions();
    fetchAccessModules();
    getMedium();
    getClass();
    getBoard();
    getSeriesCategoryData()
  }, []);

  const getMedium = async () => {
    let results = await window.Platform.database.getMedium();
    if (results?.status) {
      window.NotificationUtils.showError(results.message);
      return;
    }
    else {
      setMediumss(results?.data)
    }
  }

  const getClass = async (data) => {
    const results = await window.Platform.database.getClass(data);
    if (results?.status) {
      window.NotificationUtils.showError(results.message);
    }
    else {
      setClasseses(results?.data)
    }
  }

  const getBoard = async () => {
    let results = await window.Platform.database.getBoard();
    if(results?.status){
      window.NotificationUtils.showError(results.message);
    }
    else{
      setBoardss(results.data)
    }
  }

  const getSeriesCategoryData = async () => {
    let results = await window.Platform.database.getSeriesCategory();
    if(results?.message == "Session Expired Please LogIn Again"){
      window.NotificationUtils.showError(results.message);
    }
    else{
      setSeriesss(results.data)
    }
  }
  
         const fetchAccessModules = async () => {
        try {
            setLoading(true);
            let data = {
                pageNumber: paginationModel.page,
                recordPerPage: paginationModel.pageSize,
                userId : userData?.id,
                moduleId : "vCEa7EugnV"
            }
            let results = await window.Platform.database.fetchAccessModules(data);
            if (results?.status) {
                window.NotificationUtils.showError(results?.message || "Something went wrong");
                setLoading(false);
                return;
            }
            else {
                const jsonArrayWithId = results?.data?.map((obj, index) => ({ ...obj, idIndex: index + 1 }));
                setAccessModulesData(jsonArrayWithId);
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setLoading(false)
        }
    }

  const addVisit = () => {
    setDataModal(null);
    setVisitModal(true);
  };

  const addOlympaidProducts = () => {
    setDataModal(null);
    setOlympaidProductsModal(true);
  };
  const addMittplusProduct = () => {
    setDataModal(null);
    setMittplusProduct(true);
  };

  useEffect(() => {
    if (callApi) {
      if (selectedTab === 0) {
        fetchProduct();
      } else if (selectedTab == 1) {
        fetchProductMittplus();
      }
      else if (selectedTab == 2) {
        getMittstoreProduct();
      }
      else if( selectedTab == 3){ 
        fetchOlympaidProducts()
      }
    }
  }, [ paginationModel.page, paginationModel1.page, paginationModel.pageSize, paginationModel1.pageSize]);

  //   useEffect(() => {
  //     fetchProduct();
  // }, [selectedTab, medium, board, classes, seriess, fromDate, toDate, paginationModel.page, paginationModel.pageSize]);

  const fetchProduct = async () => {
    try {
      setLoading(true);
      let data = {
        pageNumber: paginationModel.page,
        nameSku: search,
        // startDate: fromDate,
        // endDate: toDate,
          startDate: fromDate != '' ? fromDate : filteredDate?.startDate,
          endDate: toDate != '' ? toDate : filteredDate?.endDate,
        recordPerPage: paginationModel.pageSize,
        mediumName: medium,
        boardName: board,
        className: classes,
        seriesName: seriess,
        productForm:productForm
      }
      let results = await window.Platform.database.fetchProduct1(data);
      setRowCount(results.data1);
      const jsonArrayWithId = results?.data?.map((obj, index) => ({
        ...obj,
        id: obj.skuId,
      }));
      setAccessChanges(jsonArrayWithId);
      setLoading(false);
    } catch (error) {
      window.NotificationUtils.showError("Session Expired Please LogIn Again" ||"Error Fetching Data");
      setLoading(false);
    }
  };

  const fetchProductMittplus = async () => {
    try {
      setLoading(true);
      let results = await window.Platform.database.fetchProductMittplus({
        pageNumber: paginationModel1.page,
      });
      setRowCount1(results.data1);
      const jsonArrayWithId = results?.data?.map((obj, index) => ({
        ...obj,
        id: obj.id,
      }));
      setAccessChanges(jsonArrayWithId);
      setLoading(false);
    } catch (error) {
      window.NotificationUtils.showError("Error Fetching Data");
      setLoading(false);
    }
  };

  const fetchOlympaidProducts = async () => {
    try {
      setLoading(true);
      let data = {
        pageNumber: paginationModel.page,
        nameSku: search,
        // startDate: fromDate,
        // endDate: toDate,
          startDate: fromDate != '' ? fromDate : filteredDate?.startDate,
          endDate: toDate != '' ? toDate : filteredDate?.endDate,
        recordPerPage: paginationModel.pageSize,
        mediumName: medium,
        boardName: board,
        className: classes,
        seriesName: "M70WMjstx4t"
      }
      let results = await window.Platform.database.fetchProduct1(data);
      //  let data = {
      //   pageNumber: paginationModel.page,
      //   recordPerPage: paginationModel.pageSize,
      //   questionCategory:"4"
      // }
      // let results = await window.Platform.database.getMittstoreProduct(data);
      setRowCount(results.data1);
      const jsonArrayWithId = results?.data?.map((obj, index) => ({
        ...obj,
        index1: index+1,
      }));
      setAccessChanges(jsonArrayWithId);
      setLoading(false);
    } catch (error) {
      window.NotificationUtils.showError("Error Fetching Data");
      setLoading(false);
    }
  };

   const getMittstoreProduct = async () => {
    try {
      setLoading(true);
      let data = {
        pageNumber: paginationModel.page,
        recordPerPage: paginationModel.pageSize,
        questionCategory:"3"
      }
      let results = await window.Platform.database.getMittstoreProduct(data);
      setRowCount2(results?.data1);
      const jsonArrayWithId = results?.data?.map((obj, index) => ({
        ...obj,
        index1:index+1
      }));
      setAccessChanges(jsonArrayWithId);
      setLoading(false);
    } catch (error) {
      window.NotificationUtils.showError("Error Fetching Data");
      setLoading(false);
    }
  };


  const handleEdit = (data, type) => {
    if (type === "MITTPLUS") {
      setEditMittplusProduct(true);
    } else {
      setEditModal(true);
    }
    setDataModal(data);
  };

  const deleteProduct = async (item, type) => {
    try {
      const isConfirmed = window.confirm(
        "Are you sure you want to delete this product?"
      );
      if (!isConfirmed) {
        return;
      }
      setLoading(true);
      if (type === "MITTPLUS") {
        await window.Platform.database.deleteMittplusProduct({ id: item.id });
        fetchProductMittplus();
      } else {
        await window.Platform.database.deleteProduct({ id: item.id });
        fetchProduct();
      }
      setLoading(false);
      window.NotificationUtils.showSuccess("Product deleted successfully!");
    } catch (error) {
      console.error(error);
    }
  };

  const handleTabChange = async (value) => {
    setSelectedTab(value);
    setAccessChanges([]);
  };

  const formatTimeStamp = (timestampFromDB) => {
    const options = {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    };

    const formattedDate = new Date(timestampFromDB).toLocaleString(
      "en-US",
      options
    );
    return formattedDate;
  };

  const clearFilters = async () => {

    setFromDate("")
    setToDate("")
    setBoard("");
    setClasses("");
    setMedium("");
    setSeriesS("");
    setSearch("");
    setPaginationModel((prev) => ({ ...prev, pageSize: 20 }))
    setAccessChanges([]);
    setRowCount(0);
    setSelectedSession("");
    setIsDateRangeDisabled(false);
    setIsSessionDisabled(false);
    setSelectedSession("");
    setProductForm("");
    setLoading(false);
  }

  const exportProduct = async () => {
    setLoading(true);
    try {
      let data = {
        pageNumber: paginationModel.page,
        filter: search,
        recordPerPage: paginationModel.pageSize,
        mediumName: medium,
        boardName: board,
        className: classes,
        seriesName: seriess,
        // startDate: fromDate,
        // endDate: toDate
          startDate: fromDate != '' ? fromDate : filteredDate?.startDate,
          endDate: toDate != '' ? toDate : filteredDate?.endDate,
          productForm:productForm
      };

      let result = await window.Platform.database.exportData("/product/exportProduct",
        data
      )
      const blob = new Blob([result.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "product.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Export error:", error);
    }
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        {/* <GridToolbarColumnsButton />
        <GridToolbarFilterButton />
        <GridToolbarExport
          csvOptions={{
            fileName: "export-products",
          }}
        /> */}
      </GridToolbarContainer>
    );
  }

  const handleOpenViewModal = (id) => {
    setModalData(id)
    setOpenViewModal(true);
  }

  const handleCloseViewModal = () => {
    setOpenViewModal(false);
    setModalData([]);
  }

  
  const handleOpenViewModalMittstore = async (rowData) => {
      let data = {
        questionCategory:rowData?.next_question_id
      }
      let results = await window.Platform.database.getMittstoreProduct(data);
      setModalDataMittstoreRowData(rowData);
    setModalDataMittstore(results?.data)
    setOpenViewModalMittstore(true);
  }

  const handleCloseViewModalMittstore = () => {
    setOpenViewModalMittstore(false);
    setModalDataMittstore([]);
  }


  const getEmployeeColumns = () => {
    let result = [
      {
        field: "nameSku",
        headerName: "SKU Name",
        sortable: false,
        width: 250,
        editable: false,
        valueGetter: (params) => {
          return params.row?.nameSku || "N/A";
        },
        renderCell: (params) => {
          let name = params.row?.nameSku;
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          );
        },
      },

      {
        field: "skuCode",
        headerName: "SKU Code",
        width: 170,
        sortable: false,
        valueGetter: (params) => {
          return params.row?.sku_code || "N/A";
        },
        renderCell: (params) => {
          let name = params.row?.sku_code;
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          );
        },
      },

      {
        field: "type",
        headerName: "Book Type",
        width: 200,
        sortable: false,
        valueGetter: (params) => {
          return params.row?.type || "N/A";
        },
        renderCell: (params) => {
          let name = params.row?.type || "N/A";
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          );
        },
      },

      {
        field: "unitPrice",
        headerName: "Unit Price",
        width: 200,
        sortable: false,
        valueGetter: (params) => {
          return params.row?.unitPrice || "N/A";
        },
        renderCell: (params) => {
          let name = +params.row?.unitPrice;
          let name1 = name?.toFixed(2);
          return (
            <Tooltip title={name1 || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name1 || "N/A"}</Typography>
            </Tooltip>
          );
        },
      },
      {
        field: "View",
        headerName: "View",
        minWidth: 120,
        flex: 0.17,
        editable: false,
        renderCell: (params) => {
          return (
            <>
              <Tooltip>
                <span>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => handleOpenViewModal(params.row)}
                    sx={{ minWidth: "80px" }}
                  >
                    {"View"}
                  </Button>
                </span>
              </Tooltip>
              <Modal open={openViewModal} onClose={handleCloseViewModal}>
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "80%",
                    maxWidth: 900,
                    bgcolor: "white",
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    maxHeight: "90%",
                    overflowY: "auto",
                  }}
                >
                  <Typography variant="h6" component="h2" mb={5} style={{ textAlign: "center" }}>
                    Product Details
                  </Typography>
                  <div>
                    <div className="row mb-4 mt-2">
                      <div className="col-md-6">
                        <b> SKU Name :</b> {modalData && modalData?.nameSku || "N/A"}
                      </div>

                      <div className="col-md-6">
                        <b>SKU Code : </b> {modalData && modalData?.sku_code || "N/A"}
                      </div>

                    </div>
                    <div className="row mb-4">

                      <div className="col-md-6">
                        <b> Series Name : </b>{modalData && modalData?.seriesName || "N/A"}
                      </div>

                      <div className="col-md-6">
                        <b>Subject Name :</b> {modalData && modalData?.subjectName || "N/A"}
                      </div>

                    </div>
                    <div className="row mb-4">
                      <div className="col-md-6">
                        <b>Medium Name :</b> {modalData && modalData?.mediumName || "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b>Class Name :</b> {modalData && modalData?.className || "N/A"}
                      </div>

                    </div>

                    <div className="row mb-4">
                      <div className="col-md-6">
                        <b>Board Name :</b> {modalData && modalData?.boardName || "N/A"}
                      </div>

                      <div className="col-md-6">
                        <b>Unit Price :</b> {modalData && modalData?.unitPrice || "N/A"}
                      </div>

                    </div>

                    <div className="row mb-4">
                      <div className="col-md-6">
                        <b> Type :</b> {modalData && modalData?.type || "N/A"}
                      </div>


                    </div>
                  </div>
                  <Box mt={2} display="flex" justifyContent="flex-end">
                    <Button onClick={handleCloseViewModal} variant="contained" color="primary">
                      Close
                    </Button>
                  </Box>
                </Box>
              </Modal>
            </>
          );
        },
      },

       accessModulesData && accessModulesData[0]?.is_approve?.toLowerCase() != "no" &&  {
        field: "Actions",
        headerName: "Actions",
        editable: false,
        hide: true,
        minWidth: 150,
        filterable: false,
        disableExport: true,
        renderCell: (params) => {
          return (
            <>
              <Tooltip title={"Edit Product"}>
                <IconButton onClick={() => handleEdit(params.row, "MITTSURE")}>
                  <DriveFileRenameOutlineIcon sx={{ color: "black", fontSize: "22px", fontWeight: "400" }} />
                </IconButton>
              </Tooltip>
              <Tooltip title={"Delete Product"}>
                <IconButton
                  onClick={() => deleteProduct(params.row, "MITTSURE")}
                >
                  <DeleteIcon sx={{ color: "red", fontSize: "22px", fontWeight: "400" }} />
                </IconButton>
              </Tooltip>
            </>
          );
        },
      },
    ];
    return result;
  };

  const getMittplusColumns = () => {
    let result = [
      {
        field: "productTypeName",
        headerName: "Product Type",
        width: 210,
        sortable: false,
        valueGetter: (params) => {
          return params.row?.productTypeName || "N/A";
        },
        renderCell: (params) => {
          let name = params.row?.productTypeName;
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          );
        },
      },
      {
        field: "productName",
        headerName: "Product Name",
        sortable: false,
        width: 170,
        editable: false,
        valueGetter: (params) => {
          return params.row?.product_name || "N/A";
        },
        renderCell: (params) => {
          let name = params.row?.product_name;
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          );
        },
      },
      {
        field: "invoice",
        headerName: "Invoice",
        width: 130,
        sortable: false,
        valueGetter: (params) => {
          return params.row?.invoice || "N/A";
        },
        renderCell: (params) => {
          let name = params.row?.invoice;
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          );
        },
      },
      {
        field: "class",
        headerName: "Class",
        width: 150,
        sortable: false,
        valueGetter: (params) => {
          return params.row?.className || "N/A";
        },
        renderCell: (params) => {
          let name = params.row?.className;
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          );
        },
      },
      {
        field: "access_code_purchased",
        headerName: "Access Code Purchased",
        width: 160,
        sortable: false,
        valueGetter: (params) => {
          return params.row?.access_code_purchased || "N/A";
        },
        renderCell: (params) => {
          let name = params.row?.access_code_purchased;
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          );
        },
      },
      {
        field: "landingCost",
        headerName: "Landing Cost",
        width: 150,
        sortable: false,
        valueGetter: (params) => {
          return params.row?.landing_cost || "N/A";
        },
        renderCell: (params) => {
          let name = params.row?.landing_cost;
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          );
        },
      },
      {
        field: "validity_end_date",
        headerName: "Validity End Date",
        width: 120,
        sortable: false,
        valueGetter: (params) => {
          return params.row?.validity_end_date
            ? formatTimeStamp(params.row?.validity_end_date)
            : "N/A";
        },
        renderCell: (params) => {
          let name = params.row?.validity_end_date
            ? formatTimeStamp(params.row?.validity_end_date)
            : "N/A";
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          );
        },
      },
      {
        field: "Actions",
        headerName: "Actions",
        editable: false,
        hide: true,
        minWidth: 150,
        filterable: false,
        disableExport: true,
        renderCell: (params) => {
          return (
            <>
              <Tooltip title={"Edit Mittplus Product"}>
                <IconButton onClick={() => handleEdit(params.row, "MITTPLUS")}>
                  <DriveFileRenameOutlineIcon sx={{ color: "black", fontSize: "22px", fontWeight: "400" }} />
                </IconButton>
              </Tooltip>
              <Tooltip title={"Delete Mittplus Product"}>
                <IconButton
                  onClick={() => deleteProduct(params.row, "MITTPLUS")}
                >
                  <DeleteIcon sx={{ color: "red", fontSize: "22px", fontWeight: "500" }} />
                </IconButton>
              </Tooltip>
            </>
          );
        },
      },
    ];
    return result;
  };

  const getMittStoreEmployeeColumns = () => {
    let result = [
      {
        field: "nameSku",
        headerName: "Category",
        sortable: false,
        width: 450,
        editable: false,
        valueGetter: (params) => {
          return params.row?.option || "N/A";
        },
        renderCell: (params) => {
          let name = params.row?.option || "N/A";
          return (
            // <Tooltip title={name || "N/A"}>
            <Tooltip title={"N/A"}>
              {/* <Typography variant="inherit">{name || "N/A"}</Typography> */}
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          );
        },
      },
        {
        field: "View",
        headerName: "View",
        minWidth: 180,
        editable: false,
        renderCell: (params) => {
          return (
            <>
              <Tooltip>
                <span>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => handleOpenViewModalMittstore(params.row)}
                    sx={{ minWidth: "80px" }}
                  >
                    {"View"}
                  </Button>
                </span>
              </Tooltip>
              <Modal open={openViewModalMittstore} onClose={handleCloseViewModalMittstore}>
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "80%",
                    maxWidth: 900,
                    bgcolor: "white",
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    maxHeight: "90%",
                    overflowY: "auto",
                  }}
                >
                  <Typography variant="h6" component="h2" mb={5} style={{ textAlign: "center" }}>
                    {modalDataMittstoreRowData?.option ||  ""} Product
                  </Typography>
                  <div>

                   {modalDataMittstore && modalDataMittstore?.map((ele, index)=>{

                    return <div className="row mb-4 mt-2">
                      <div className="col-md-6">
                       {index+1} . <span style={{fontSize:"14px", color:"#000", fontWeight:"500"}}>{ele?.option || "N/A"}</span>
                      </div>
                    </div>})}
                  </div>
                  <Box mt={2} display="flex" justifyContent="flex-end">
                    <Button onClick={handleCloseViewModalMittstore} variant="contained" color="primary">
                      Close
                    </Button>
                  </Box>
                </Box>
              </Modal>
            </>
          );
        },
      },

      // {
      //   field: "skuCode",
      //   headerName: "SKU Code",
      //   width: 170,
      //   sortable: false,
      //   valueGetter: (params) => {
      //     return params.row?.sku_code || "N/A";
      //   },
      //   renderCell: (params) => {
      //     let name = params.row?.sku_code;
      //     return (
      //       // <Tooltip title={name || "N/A"}>
      //       <Tooltip title={"N/A"}>
      //         <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{"N/A"}</Typography>
      //         {/* <Typography variant="inherit">{name || "N/A"}</Typography> */}
      //       </Tooltip>
      //     );
      //   },
      // },

      // {
      //   field: "type",
      //   headerName: "Book Type",
      //   width: 200,
      //   sortable: false,
      //   valueGetter: (params) => {
      //     return params.row?.type || "N/A";
      //   },
      //   renderCell: (params) => {
      //     let name = params.row?.type || "N/A";
      //     return (
      //       <Tooltip title={"N/A"}>
      //         {/* <Tooltip title={name || "N/A"}> */}
      //         {/* <Typography variant="inherit">{name || "N/A"}</Typography> */}
      //         <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{"N/A"}</Typography>
      //       </Tooltip>
      //     );
      //   },
      // },

      // {
      //   field: "unitPrice",
      //   headerName: "Unit Price",
      //   width: 200,
      //   sortable: false,
      //   valueGetter: (params) => {
      //     return params.row?.unitPrice || "N/A";
      //   },
      //   renderCell: (params) => {
      //     let name = +params.row?.unitPrice;
      //     let name1 = name?.toFixed(2);
      //     return (
      //       <Tooltip title={"N/A"}>
      //         {/* <Tooltip title={name1 || "N/A"}> */}
      //         {/* <Typography variant="inherit">{name1 || "N/A"}</Typography> */}
      //         <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{"N/A"}</Typography>
      //       </Tooltip>
      //     );
      //   },
      // },
      // {
      //   field: "Actions",
      //   headerName: "Actions",
      //   editable: false,
      //   hide: true,
      //   minWidth: 150,
      //   filterable: false,
      //   disableExport: true,
      //   renderCell: (params) => {
      //     return (
      //       <>
      //         <Tooltip title={"Edit Product"}>
      //           {/* <IconButton onClick={() => handleEdit(params.row, "MITTSURE")}> */}
      //           <IconButton>
      //             <DriveFileRenameOutlineIcon sx={{ color: "black", fontSize: "22px", fontWeight: "500" }} />
      //           </IconButton>
      //         </Tooltip>
      //         <Tooltip title={"Delete Product"}>
      //           <IconButton
      //           // onClick={() => deleteProduct(params.row, "MITTSURE")}
      //           >
      //             <DeleteIcon sx={{ color: "red", fontSize: "22px", fontWeight: "500" }} />
      //           </IconButton>
      //         </Tooltip>
      //       </>
      //     );
      //   },
      // },
    ];
    return result;
  }

  const getOlympaidEmployeeColumns = () => {
    let result = [
      {
        field: "nameSku",
        headerName: "SKU Name",
        sortable: false,
        width: 250,
        editable: false,
        valueGetter: (params) => {
          return params.row?.nameSku || "N/A";
        },
        renderCell: (params) => {
          let name = params.row?.nameSku;
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          );
        },
      },

      {
        field: "skuCode",
        headerName: "SKU Code",
        width: 170,
        sortable: false,
        valueGetter: (params) => {
          return params.row?.sku_code || "N/A";
        },
        renderCell: (params) => {
          let name = params.row?.sku_code;
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          );
        },
      },

      {
        field: "type",
        headerName: "Book Type",
        width: 200,
        sortable: false,
        valueGetter: (params) => {
          return params.row?.type || "N/A";
        },
        renderCell: (params) => {
          let name = params.row?.type || "N/A";
          return (
            <Tooltip title={name || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name || "N/A"}</Typography>
            </Tooltip>
          );
        },
      },

      {
        field: "unitPrice",
        headerName: "Unit Price",
        width: 200,
        sortable: false,
        valueGetter: (params) => {
          return params.row?.unitPrice || "N/A";
        },
        renderCell: (params) => {
          let name = +params.row?.unitPrice;
          let name1 = name?.toFixed(2);
          return (
            <Tooltip title={name1 || "N/A"}>
              <Typography variant="inherit" sx={{ color: "black", fontSize: "12px", fontWeight: "500" }}>{name1 || "N/A"}</Typography>
            </Tooltip>
          );
        },
      },
      {
        field: "View",
        headerName: "View",
        minWidth: 120,
        flex: 0.17,
        editable: false,
        renderCell: (params) => {
          return (
            <>
              <Tooltip>
                <span>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => handleOpenViewModal(params.row)}
                    sx={{ minWidth: "80px" }}
                  >
                    {"View"}
                  </Button>
                </span>
              </Tooltip>
              <Modal open={openViewModal} onClose={handleCloseViewModal}>
                <Box
                  sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "80%",
                    maxWidth: 900,
                    bgcolor: "white",
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    maxHeight: "90%",
                    overflowY: "auto",
                  }}
                >
                  <Typography variant="h6" component="h2" mb={5} style={{ textAlign: "center" }}>
                    Product Details
                  </Typography>
                  <div>
                    <div className="row mb-4 mt-2">
                      <div className="col-md-6">
                        <b> SKU Name :</b> {modalData && modalData?.nameSku || "N/A"}
                      </div>

                      <div className="col-md-6">
                        <b>SKU Code : </b> {modalData && modalData?.sku_code || "N/A"}
                      </div>

                    </div>
                    <div className="row mb-4">

                      <div className="col-md-6">
                        <b> Series Name : </b>{modalData && modalData?.seriesName || "N/A"}
                      </div>

                      <div className="col-md-6">
                        <b>Subject Name :</b> {modalData && modalData?.subjectName || "N/A"}
                      </div>

                    </div>
                    <div className="row mb-4">
                      <div className="col-md-6">
                        <b>Medium Name :</b> {modalData && modalData?.mediumName || "N/A"}
                      </div>
                      <div className="col-md-6">
                        <b>Class Name :</b> {modalData && modalData?.className || "N/A"}
                      </div>

                    </div>

                    <div className="row mb-4">
                      <div className="col-md-6">
                        <b>Board Name :</b> {modalData && modalData?.boardName || "N/A"}
                      </div>

                      <div className="col-md-6">
                        <b>Unit Price :</b> {modalData && modalData?.unitPrice || "N/A"}
                      </div>

                    </div>

                    <div className="row mb-4">
                      <div className="col-md-6">
                        <b> Type :</b> {modalData && modalData?.type || "N/A"}
                      </div>


                    </div>
                  </div>
                  <Box mt={2} display="flex" justifyContent="flex-end">
                    <Button onClick={handleCloseViewModal} variant="contained" color="primary">
                      Close
                    </Button>
                  </Box>
                </Box>
              </Modal>
            </>
          );
        },
      },

    ];
    return result;
  };

  const renderContent = () => {
    return (
      <>
        <div className="d-flex justify-content-end align-items-center  py-2">
          <Typography variant="body1" sx={{ fontSize: "14px", color: "black", fontWeight: "500" }}>Select Page Size:&nbsp; </Typography>
          <Select
            value={paginationModel.pageSize}
            variant="outlined"
            size="small"
            onChange={(e) => { setPaginationModel({ ...paginationModel, pageSize: e.target.value }) }}
            sx={{ width: 90, fontSize: 14, fontWeight: "500" }}
          >
            {[10, 20, 30, 50, 100].map((role) => (
              <MenuItem sx={{ width: 90, fontSize: 14, fontWeight: "500" }} key={role} value={role}>{role}</MenuItem>
            ))}
          </Select>
        </div>
        <Box style={{ height: !accessChanges?.length ? "200px" : "auto" }}>
          <DataGridContainer>
            <DataGrid
              className="payrollGrid"
              density="compact"
              rows={accessChanges || []}
              columns={getEmployeeColumns()}
              sx={{ color: "black", fontSize: "14px", fontWeight: "400" }}
              rowHeight={60}
              disableDensitySelector
              disableSelectionOnClick
              disableRowSelectionOnClick
              // initialState={{
              //   pagination: {
              //     paginationModel: {
              //       pageSize: 10,
              //     },
              //   },
              // }}
              filterMode="server"
              paginationModel={paginationModel}
              paginationMode="server"
              onPaginationModelChange={setPaginationModel}
              rowCount={rowCount}
              pageSizeOptions={[10]}
              components={{
                Toolbar: CustomToolbar,
              }}
            />
          </DataGridContainer>
        </Box>
      </>
    );
  };

  const renderContentMittplus = () => {
    return (
      <Box style={{ height: !accessChanges?.length ? "200px" : "auto" }}>
        <DataGridContainer>
          <DataGrid
            className="payrollGrid"
            density="compact"
            rows={accessChanges || []}
            columns={getMittplusColumns()}
            sx={{ color: "black", fontSize: "14px", fontWeight: "600" }}
            rowHeight={60}
            disableDensitySelector
            disableSelectionOnClick
            disableRowSelectionOnClick
            // initialState={{
            //   pagination: {
            //     paginationModel: {
            //       pageSize: 10,
            //     },
            //   },
            // }}
            filterMode="server"
            paginationModel={paginationModel1}
            paginationMode="server"
            onPaginationModelChange={setPaginationModel1}
            rowCount={rowCount1}
            pageSizeOptions={[10]}
            components={{
              Toolbar: CustomToolbar,
            }}
          />
        </DataGridContainer>
      </Box>
    );
  };

  const renderContetMittStore = () => {
    return (
      <>
        <div className="d-flex justify-content-end align-items-center  py-2">
                          <Typography variant="body1">Select Page Size:&nbsp; </Typography>
                      <Select
                        value={paginationModel.pageSize}
                        variant="outlined"
                        size="small"
                        onChange={(e)=>{setPaginationModel({...paginationModel,pageSize:e.target.value})}}
                        sx={{ width: 90, fontSize: 14 }}
                      >
                        {[10,20,30,50,100].map((role) => (
                          <MenuItem key={role} value={role}>{role}</MenuItem>
                        ))}
                      </Select>
                          </div>
        <Box style={{ height: !accessChanges?.length ? "200px" : "auto" }}>
          <DataGridContainer>
            <DataGrid
              className="payrollGrid"
              density="compact"
              rows={accessChanges || []}
              columns={getMittStoreEmployeeColumns()}
              sx={{ color: "black", fontSize: "14px", fontWeight: "600" }}
              rowHeight={60}
              disableDensitySelector
              disableSelectionOnClick
              disableRowSelectionOnClick
              // initialState={{
              //   pagination: {
              //     paginationModel: {
              //       pageSize: 10,
              //     },
              //   },
              // }}
              getRowId={(row, index) => `${row?.index1}` || index}
              filterMode="server"
              paginationModel={paginationModel}
              paginationMode="server"
              onPaginationModelChange={setPaginationModel}
              rowCount={rowCount2}
              pageSizeOptions={[10]}
              components={{
                Toolbar: CustomToolbar,
              }}
            />
          </DataGridContainer>
        </Box>
      </>
    );
  }

  const renderContentOlympaid = () => {
    return (
      <>
        {/* <div className="d-flex justify-content-end align-items-center  py-2">
                          <Typography variant="body1">Select Page Size:&nbsp; </Typography>
                      <Select
                        value={paginationModel.pageSize}
                        variant="outlined"
                        size="small"
                        onChange={(e)=>{setPaginationModel({...paginationModel,pageSize:e.target.value})}}
                        sx={{ width: 90, fontSize: 14 }}
                      >
                        {[10,20,30,40,50,60].map((role) => (
                          <MenuItem key={role} value={role}>{role}</MenuItem>
                        ))}
                      </Select>
                          </div> */}
        <Box style={{ height: !accessChanges?.length ? "200px" : "auto" }}>
          <DataGridContainer>
            <DataGrid
              className="payrollGrid"
              density="compact"
              rows={accessChanges || []}
              columns={getOlympaidEmployeeColumns()}
              sx={{ color: "black", fontSize: "14px", fontWeight: "600" }}
              rowHeight={60}
              disableDensitySelector
              disableSelectionOnClick
              disableRowSelectionOnClick
              // initialState={{
              //   pagination: {
              //     paginationModel: {
              //       pageSize: 10,
              //     },
              //   },
              // }}
              filterMode="server"
              paginationModel={paginationModel}
              getRowId={(row, index) => `${row?.index1}` || index}
              paginationMode="server"
              onPaginationModelChange={setPaginationModel}
              rowCount={rowCount}
              pageSizeOptions={[10]}
              components={{
                Toolbar: CustomToolbar,
              }}
            />
          </DataGridContainer>
        </Box>
      </>
    );
  };
  return (
    <>
      <StaffEditorPageContainer>
        <HeaderContainer>
          {/* <div style={{ width: "100%", display: "flex", flexDirection: "row", gap: "10px" }}> */}
            {/* <Box display="flex" alignItems="center" gap={3} flexWrap="wrap"> */}
            <Box sx={{ mt: 1, width: "100%" }}>

              <Paper elevation={3}
                sx={{
                  p: 2,
                  mb: 2,
                  width: '100%',        // takes full width of parent
                  // maxWidth: '1000px',   // optional: control max width
                  mx: 'auto',
                  backgroundColor: "#ebf0fa"          // center it horizontally
                }}>
                {/* <Box display="flex" alignItems="center" gap={2} flexWrap="wrap"> */}
                <div className="row">
                  <div className="col-md-3">
                  <FormControl fullWidth>
                      <Tooltip title="Search By SKU Name">
                      <TextField
                        variant="outlined"
                        size="small"
                        placeholder="Search By SKU Name"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        sx={{ fontSize: 14 }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Search color="action" />
                            </InputAdornment>
                          )
                        }}
                      />
                    </Tooltip>
                  </FormControl>
                  </div>

                  <div className="col-md-3">
                    <FormControl fullWidth size="small">
                      <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select Medium</InputLabel>
                      <Select
                        fullWidth
                        label="Select Medium"
                        value={medium}
                        // variant="outlined"
                        size="small"
                        onChange={(e) => { setMedium(e.target.value) }}
                        sx={{ fontSize: 14, fontWeight: "500", color: "black" }}
                      >
                        <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>All</MenuItem>
                        {mediumss.map((role) => (
                          <MenuItem key={role} value={role.mediumTableId} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>{role.mediumName}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div className="col-md-2">
                    <FormControl fullWidth size="small">
                      <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select Class</InputLabel>
                      <Select
                        label="Select Class"
                        fullWidth
                        value={classes}
                        // variant="outlined"
                        size="small"
                        onChange={(e) => { setClasses(e.target.value) }}
                        sx={{ fontSize: 14 }}
                      >
                        <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>All</MenuItem>
                        {classeses.map((role) => (
                          <MenuItem key={role} value={role.classId} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>{role.className}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div className="col-md-2">
                    <FormControl fullWidth size="small">
                      <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select Board</InputLabel>
                      <Select
                        value={board}
                        // variant="outlined"
                        label="Select Board"
                        size="small"
                        onChange={(e) => { setBoard(e.target.value) }}
                        sx={{ fontSize: 14 }}
                      >
                        <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>All</MenuItem>
                        {boardss.map((role) => (
                          <MenuItem key={role} value={role.boardId} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>{role.boardName}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>

                  <div className="col-md-2">
                    <FormControl fullWidth size="small">
                      <InputLabel sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>Select Series</InputLabel>
                      <Select
                        label="Select Series"
                        value={seriess}
                        // variant="outlined"
                        size="small"
                        onChange={(e) => { setSeriesS(e.target.value) }}
                        sx={{ fontSize: 14 }}
                      >
                        <MenuItem value="" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>All</MenuItem>
                        {seriesss.map((role) => (
                          <MenuItem key={role} value={role.seriesTableId} sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>{role.seriesName}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-md-3">
                    {/* <Typography variant="body1" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>From Date</Typography>
                    <input fullWidth type="date" className="form-control w-auto" value={fromDate} onChange={(e) => { setFromDate(e.target.value) }} /> */}
                    <FormControl fullWidth size="small">
                      <TextField label="From Date" size="small"   type="date" sx={{ color: "black", fontSize: "13px", fontWeight: 500 }} className="form-control" value={fromDate} 
                      // onChange={(e) => setFromDate(e.target.value)}
                        disabled={isDateRangeDisabled}
                        onChange={(e) => {
                        const value = e.target.value;
                        setFromDate(value);
                        if (value) {
                          setIsSessionDisabled(true);
                          setSelectedSession("");
                        } else if (!value && !toDate) {
                          setIsSessionDisabled(false);
                        }
                      }}
                        InputLabelProps={{
                          shrink: true,
                          style: { color: "black", fontSize: "13px", fontWeight: 500 }
                        }}
                        inputProps={{
                          style: { color: "black", fontSize: "13px", fontWeight: 500 }
                        }} />
                    </FormControl>
                  </div>
                  <div className="col-md-3">
                    {/* <Typography variant="body1" sx={{ color: "black", fontSize: "14px", fontWeight: "500" }}>To Date:</Typography>
                    <input type="date" className="form-control w-auto" value={toDate} onChange={(e) => { setToDate(e.target.value) }} /> */}
                    <FormControl fullWidth size="small">
                      <TextField label="To Date" size="small" type="date" sx={{ color: "black", fontSize: "13px", fontWeight: 500 }} className="form-control" value={toDate} 
                      // onChange={(e) => setToDate(e.target.value)}
                      disabled={isDateRangeDisabled}
                      onChange={(e) => {
                        const value = e.target.value;
                        setToDate(value);
                        if (value) {
                          setIsSessionDisabled(true);
                          setSelectedSession("");
                        } else if (!value && !fromDate) {
                          setIsSessionDisabled(false);
                        }
                      }}
                        InputLabelProps={{
                          shrink: true,
                          style: { color: "black", fontSize: "13px", fontWeight: 500 }
                        }}
                        inputProps={{
                          style: { color: "black", fontSize: "13px", fontWeight: 500 }
                        }} />
                    </FormControl>
                  </div>
                <div className="col-md-2">
                  <Button fullWidth size="samll" variant="contained" startIcon={<img src={searchIcon} alt="icon" height={"21"} width={"21"} />} color="primary" style={{ fontSize: "14px" }} sx={{ borderRadius: '10px' }}
                    // onClick={() => { selectedTab == 0 ? fetchProduct() : selectedTab == 1 ? fetchProductMittplus() : selectedTab == 2 ? getMittstoreProduct() : selectedTab == 3 ? fetchOlympaidProducts() : null }}
                    onClick={() => {
                      setCallApi(true);
                      const actions = {
                        0: fetchProduct,
                        1: fetchProductMittplus,
                        2: getMittstoreProduct,
                        3: fetchOlympaidProducts,
                      };

                      actions[selectedTab]?.();
                    }}

                  > Find
                  </Button>
                </div>
                <div className="col-md-2">
                  <Button fullWidth size="samll" variant="contained" startIcon={<img src={clearFilterImage} alt="icon" height={"19"} width={"19"} />} color="secondary" sx={{ fontSize: '14px', borderRadius: '10px' }} onClick={() => { clearFilters() }}>Clear Filters</Button>
                  </div>
                  {selectedTab == 0 && accessModulesData && accessModulesData[0]?.is_download?.toLowerCase() != "no" &&  <div className="col-md-2">
                    <Button fullWidth size="samll" variant="contained" color="success" style={{ fontSize: "14px" }} sx={{ borderRadius: '10px' }} onClick={() => { exportProduct() }}> <FileDownloadIcon sx={{ mr: 1 }} /> Download</Button>
                  </div>}
                </div>
                 <div className="row mt-2">
                {/* <div className="col-md-3">
                                                        <FormControl fullWidth size="small">
                                                          <InputLabel
                                                            sx={{ fontSize: "14px", fontWeight: "500", color: "#000" }}
                                                          >
                                                            Select Session
                                                          </InputLabel>
                                                          <Select
                                                            label="Select Session"
                                                            value={selectedSession}
                                                            disabled={isSessionDisabled}
                                                            sx={{ fontSize: "14px", fontWeight: "500", color: "#000" }}
                                                            onChange={(e) => {
                                                              const selected = sessions.find((item) => item.id === e.target.value);
                                                              setSelectedSession(e.target.value);
                                    
                                                              if (selected) {
                                                                // ✅ Convert UTC → IST (local date)
                                                                const start = new Date(selected.startDate);
                                                                const end = new Date(selected.endDate);
                                    
                                                                const startIST = new Date(start.getTime() + (5.5 * 60 * 60 * 1000))
                                                                  .toISOString()
                                                                  .split("T")[0];
                                                                const endIST = new Date(end.getTime() + (5.5 * 60 * 60 * 1000))
                                                                  .toISOString()
                                                                  .split("T")[0];
                                    
                                                                setFromDate(startIST);
                                                                setToDate(endIST);
                                    
                                                                // ✅ Disable manual date range if session chosen
                                                                setIsDateRangeDisabled(true);
                                                              } else {
                                                                // ✅ If cleared, re-enable date inputs
                                                                setIsDateRangeDisabled(false);
                                                              }
                                                            }}
                                    
                                                          >
                                                            <MenuItem value="">
                                                              <em>Select Session</em>
                                                            </MenuItem>
                                                            {sessions.map((s) => (
                                                              <MenuItem key={s.id} value={s.id}>
                                                                {s.sessionName}
                                                              </MenuItem>
                                                            ))}
                                                          </Select>
                                                        </FormControl>
                                                      </div> */}
                                                        {selectedTab == 0 && <div className="col-md-3">
                                                        <FormControl fullWidth size="small">
                                                          <InputLabel
                                                            sx={{ fontSize: "14px", fontWeight: "500", color: "#000" }}
                                                          >
                                                            Product Form
                                                          </InputLabel>
                                                          <Select
                                                            label="Product Form"
                                                            value={productForm}
                                                            sx={{ fontSize: "14px", fontWeight: "500", color: "#000" }}
                                                            onChange={(e) => setProductForm(e.target.value)}
                                                          >
                                                            <MenuItem value="">
                                                              Select Product Form
                                                            </MenuItem>
                                                              <MenuItem key={1} value={"product"}>
                                                                Product
                                                              </MenuItem>
                                                               <MenuItem key={2} value={"specimen"}>
                                                                Specimen
                                                              </MenuItem>
                                                          </Select>
                                                        </FormControl>
                                                      </div>}
              </div>
                {/* </Box> */}
              </Paper>
              <Box display="flex" justifyContent="space-between" gap={2}>
                 <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  px: 2,
                  py: 1,
                  background: "#e8f5e9",
                  border: "1px solid #a5d6a7",
                  borderLeft: "4px solid #2e7d32",
                  borderRadius: "8px",
                  boxShadow: "0 2px 6px rgba(0,0,0,0.08)",
                  width: "fit-content",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "13px",
                    fontWeight: 600,
                    color: "#1b5e20",
                    letterSpacing: "0.3px",
                  }}
                >
                  Total Entries:
                </Typography>
                <Typography
                  sx={{
                    fontSize: "15px",
                    fontWeight: 700,
                    color: "#2e7d32",
                    background: "#fff",
                    px: 1.2,
                    py: 0.2,
                    borderRadius: "6px",
                    border: "1px solid #a5d6a7",
                    minWidth: "28px",
                    textAlign: "center",
                  }}
                >
                  {accessChanges?.length > 0 ? rowCount : 0 || 0}
                </Typography>
              </Box>

                {/* <Box display="flex" alignItems="end" gap={1} flexWrap="wrap"> */}
            { accessModulesData && accessModulesData[0]?.is_add?.toLowerCase() != "no" &&      <div>
                  {selectedTab === 0 && (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => setSeries(true)}
                      sx={{ mr: 1, borderRadius: "10px" }}
                    >
                      <Add sx={{ mr: 1 }} />
                      Add Series
                    </Button>
                  )}

                  {selectedTab === 0 && (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => setBulk(true)}
                      sx={{ mr: 1, borderRadius: "10px" }}
                    >
                      <DriveFolderUploadIcon sx={{ mr: 1 }} />
                      Bulk Add
                    </Button>
                  )}

                 {selectedTab == 0 || selectedTab == 1 && <Button
                    variant="contained"
                    color="primary"
                    onClick={
                      selectedTab === 0
                        ? () => addVisit()
                        : selectedTab == 1 ? () => addMittplusProduct()
                          : () => addOlympaidProducts()
                    }
                    sx={{ mr: 1, borderRadius: "10px" }}
                  >
                    <Add sx={{ mr: 1 }} />
                    Add New
                  </Button>}
                </div>}


              </Box>
            </Box>
          {/* </div> */}


        </HeaderContainer>

        <TableContainer>
          <TabsContainer>
            <StyledTabs
              variant="fullWidth"
              value={selectedTab}
              onChange={(event, value) => handleTabChange(value)}
              indicatorColor="none"
              textColor="primary"
            >
              <Tab label="Mittsure"  sx={{ fontSize: "15px", color: "#000", fontWeight:"600", backgroundColor: selectedTab == 0 ? "#fff" : "#e6e3e3de " }} />
              <Tab label="Mittplus"  sx={{ fontSize: "15px", color: "#000", fontWeight:"600", backgroundColor: selectedTab == 1 ? "#fff" : "#e6e3e3de " }} />
              <Tab label="MittStore"  sx={{ fontSize: "15px", color: "#000", fontWeight:"600", backgroundColor: selectedTab == 2 ? "#fff" : "#e6e3e3de " }} />
              <Tab label="Olympiad"  sx={{ fontSize: "15px", color: "#000", fontWeight:"600", backgroundColor: selectedTab == 3 ? "#fff" : "#e6e3e3de " }} />
            </StyledTabs>
            {loading && <OpaqueLoading />}
            {selectedTab === 0 ? renderContent() : selectedTab == 1 ? renderContentMittplus() : selectedTab == 2 ? renderContetMittStore() : renderContentOlympaid()}
          </TabsContainer>
        </TableContainer>
      </StaffEditorPageContainer>
      {visitModal && (
        <ProductModal
          onClose={() => setVisitModal(false)}
          loading={loading}
          fetchData={() => fetchProduct()}
          props={dataModal}
          status={true}
        />
      )}
      {editModal && (
        <ProductModal
          onClose={() => setEditModal(false)}
          loading={loading}
          fetchData={() => fetchProduct()}
          props={dataModal}
          status={false}
        />
      )}
      {mittplusProduct && (
        <ProductMittplusModal
          onClose={() => setMittplusProduct(false)}
          loading={loading}
          props={dataModal}
          fetchData={() => fetchProductMittplus()}
          status={true}
        />
      )}
      {editMittplusProduct && (
        <ProductMittplusModal
          onClose={() => setEditMittplusProduct(false)}
          loading={loading}
          props={dataModal}
          fetchData={() => fetchProductMittplus()}
          status={false}
        />
      )}
      {series && (
        <SeriesCategory
          onClose={() => setSeries(false)}
          loading={loading}
          fetchData={
            selectedTab === 0
              ? () => fetchProduct()
              : selectedTab === 1 ? () => fetchProductMittplus()
                : () => fetchOlympaidProducts()
          }
          status={true}
        />
      )}
      {bulk && (
        <BulkProductAdd
          onClose={() => setBulk(false)}
          fetchData={
            selectedTab === 0
              ? () => fetchProduct()
              : selectedTab == 1 ? () => fetchProductMittplus()
                : () => fetchOlympaidProducts()
          }
        />
      )}
    </>
  );
};

export default ProductManagement;
